import React from "react";
import { useParams } from "react-router-dom";
import ListDataOrganisasiDetailDataOpenData from "./organisasi/ListDataOrganisasiDetailDataOpenData";
import ListDataKumpulanDataCompOpenData from "../../components/open_data/kumpulan_data/ListDataKumpulanDataCompOpenData";

const PagesOrganisasiDetailDataOpenData = ({formatDate})=>{
    const { orgName } = useParams(); // ← ambil orgName dari URL
    
    return(
        <div>
            <ListDataKumpulanDataCompOpenData formatDate={formatDate} />
        </div>
    )
}

export default PagesOrganisasiDetailDataOpenData;